import { useState, useEffect } from "react";
import { apiFetchBlob } from "../../../lib/api/client";

const blobCache = new Map<string, string>();

interface ImageThumbnailProps {
  readonly imageId: string;
  readonly alt: string;
  readonly className?: string;
  readonly onClick?: () => void;
}

export function ImageThumbnail({ imageId, alt, className, onClick }: ImageThumbnailProps) {
  const [src, setSrc] = useState<string | null>(blobCache.get(imageId) ?? null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (blobCache.has(imageId)) return;

    const controller = new AbortController();

    async function load() {
      try {
        const blob = await apiFetchBlob(`/images/${imageId}`);
        if (controller.signal.aborted) return;
        const url = URL.createObjectURL(blob);
        blobCache.set(imageId, url);
        setSrc(url);
      } catch {
        if (!controller.signal.aborted) setError(true);
      }
    }

    load();
    return () => { controller.abort(); };
  }, [imageId]);

  if (error) {
    return (
      <div className={`bg-surface-alt flex items-center justify-center text-ink-faint text-[10px] rounded ${className ?? ""}`}>
        Erreur
      </div>
    );
  }

  if (!src) {
    return (
      <div className={`bg-surface-alt animate-pulse rounded ${className ?? ""}`} />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onClick={onClick}
      className={`rounded cursor-pointer hover:opacity-90 transition-opacity ${className ?? ""}`}
    />
  );
}
